import { get_attribute_value } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/attributes.js?1733898722592';

export function get_price_request(product) {
    return get_attribute_value(product, 'kw_price_request') === '1';
}
